module.exports = __webpack_public_path__ + "img/WorkSans-Light.e288d4f.svg";